export const weddingDashboardEditorialWithNoDekOptimizelyConfig = {
  // The variation represenst the Original Onboard Flow, so if it is found, show the original onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_wedding_dashboard_editorial_no_dek',
    experimentId: '13645020554',
    variationId: '13654680665'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_wedding_dashboard_editorial_no_dek',
    experimentId: '13662300568',
    variationId: '13652700571'
  }
};

// Variation A - Invites Redirect publish flow
export const testPublishWebsiteInviteRedirectVariationA = {
  554664308: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13640090411',
    variationId: '13670740198'
  },
  // Production
  566520915: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13848220237',
    variationId: '13831080255'
  }
};

// Variation B - Invites Redirect publish flow
export const testPublishWebsiteInviteRedirectVariationB = {
  // staging
  554664308: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13640090411',
    variationId: '13680310582'
  },
  // Production
  566520915: {
    pageName: 'web_actions_for_manage_cms_designs_pages',
    experimentId: '13848220237',
    variationId: '13841010402'
  }
};

// Variation B - Extended Website Onboarding - Emojis
export const extendedWebsiteOnboardOptimizelyConfigB = {
  // variation indicates user sees the extended onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_website_onboarding__extended_flow',
    experimentId: '14204430493',
    variationId: '14218590089'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_website_onboarding__extended_flow',
    experimentId: '14388610086',
    variationId: '14402400074'
  }
};

// Variation C - Extended Website Onboarding - Icons
export const extendedWebsiteOnboardOptimizelyConfigC = {
  // variation indicates user sees the extended onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_website_onboarding__extended_flow',
    experimentId: '14204430493',
    variationId: '14349660329'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_website_onboarding__extended_flow',
    experimentId: '14388610086',
    variationId: '14398040481'
  }
};

// Variation D - Extended Website Onboarding - Desktop only, icons only
export const extendedWebsiteOnboardOptimizelyConfigD = {
  // variation indicates user sees the extended onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_website_onboarding__extended_flow__d',
    experimentId: '15116450227',
    variationId: '15108380312'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_website_onboarding__extended_flow__d',
    experimentId: '15139531207',
    variationId: '15135850451'
  }
};

// Manage Page Redesign Original
export const managePageRedesignOptimizelyOriginal = {
  // variation indicates user sees the extended onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_manage_page_redesign',
    experimentId: '14885540230',
    variationId: '14899220293'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_manage_page_redesign_1',
    experimentId: '15142180912',
    variationId: '15130120903'
  }
};

// Manage Page Redesign Variation1
export const managePageRedesignOptimizelyVariation1 = {
  // variation indicates user sees the extended onboard flow.
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_manage_page_redesign',
    experimentId: '14885540230',
    variationId: '14869700174'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_manage_page_redesign_1',
    experimentId: '15142180912',
    variationId: '15106731357'
  }
};

export const fastFacetsDesktopOptimizelyTest = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_fast_facets_test_desktop',
    experimentId: '14896670642',
    variationId: '14921090486'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_fast_facets_test_desktop',
    experimentId: '14923090463',
    variationId: '14882620624'
  }
};

export const fastFacetsMobileOptimizelyTest = {
  // Staging
  554664308: {
    pageName: '554664308_url_targeting_for_fast_facets_test_mobile_web',
    experimentId: '14894800524',
    variationId: '14911210472'
  },
  // Production
  566520915: {
    pageName: '566520915_url_targeting_for_fast_facets_test_mobile_web',
    experimentId: '14913070735',
    variationId: '14919080585'
  }
};



// WEBPACK FOOTER //
// ./src/util/optimizelyConfigs.js